import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';
import { OrderByPipe } from '../../../pipes/order-by.pipe';

@Component({
  selector: 'app-interessi',
  templateUrl: './interessi.component.html',
  styleUrls: ['./interessi.component.css']
})
export class InteressiComponent extends AppComponentGenericComponent implements OnInit {
	nuovoLegale: any = {
		data : '',
		tasso : ''
	}
	legaleModificato: any = {
		id : '',
		data : '',
		tasso : ''
	}
	nuovoMoratorio: any = {
		data : '',
		tasso : '',
		comune_id : ''
	}
	moratorioModificato: any = {
		id : '',
		data : '',
		tasso : '',
		comune_id : ''
	}

	interessiLegali: any[];
	interessiMoratori: any[];

	interessiLegaliSync: Subscription;
	interessiMoratoriSync: Subscription;

	constructor(protected dataService: DataService) {
		super(dataService, 'interessi');
		this.interessiLegali = [];
		this.interessiMoratori = [];
	}

	ngOnInit() {
		this.interessiLegaliSync = this.dataService.interessiLegali$.subscribe(
			interessiLegali => {
				if (interessiLegali) {
					this.interessiLegali = interessiLegali;
				}
				else {
					this.interessiLegali = [];
				}
				this.resetLegali();
			});
		this.interessiMoratoriSync = this.dataService.interessiMoratori$.subscribe(
			interessiMoratori => {
				if (interessiMoratori) {
					this.interessiMoratori = interessiMoratori;
				}
				else {
					this.interessiMoratori = [];
				}
				this.resetMoratori();
			});
	}

	resetLegali(){
		this.nuovoLegale.data = '';
		this.nuovoLegale.tasso = '';
		this.legaleModificato.id = '';
		this.legaleModificato.data = '';
		this.legaleModificato.tasso = '';
	}

	resetMoratori(){
		this.nuovoMoratorio.data = '';
		this.nuovoMoratorio.tasso = '';
		this.nuovoMoratorio.comune_id = '';
		this.moratorioModificato.id = '';
		this.moratorioModificato.data = '';
		this.moratorioModificato.tasso = '';
		this.moratorioModificato.comune_id = '';
	}

	aggiungiInteresseLegale() {
		if (this.nuovoLegale.data != '' && this.nuovoLegale.tasso != '') {
			this.dataService.insert("interessi_legali", this.nuovoLegale, false, (error,res) => {
				if (error) {
					//this.dataService.openMessage('INSERIMENTO INTERESSE LEGALE','si è verificato un errore');
				}
				if(res){
					this.resetLegali();
				}
			});
		}
	}

	apriModificaLegale(interesse: any) {
		this.legaleModificato.id = interesse.id;
		this.legaleModificato.data = interesse.data;
		this.legaleModificato.tasso = interesse.tasso;
	}

	salvaModificaLegale() {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.legaleModificato.id });
		this.dataService.update("interessi_legali", localFilters, this.legaleModificato, false, (error,res) => {
			if(res){
				this.resetLegali();
			}
		});
	}

	annullaModificaLegale() {
		this.resetLegali();
	}

	eliminaInteresseLegale(interesse: any) {
		console.log("eliminaInteresseLegale", interesse);
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: interesse.id });

		this.dataService.delete("interessi_legali", localFilters, false, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE INTERESSE LEGALE','si è verificato un errore');
			}
			if(res){
				this.resetLegali();
			}
		});
	}

	aggiungiInteresseMoratorio() {
		if (this.nuovoMoratorio.data != '' && this.nuovoMoratorio.tasso != '') {
			this.dataService.insert("interessi_moratori", this.nuovoMoratorio, true, (error,res) => {
				if (error) {
					//this.dataService.openMessage('INSERIMENTO INTERESSE MORATORIO','si è verificato un errore');
				}
				if(res){
					this.resetMoratori();
				}
			});
		}
	}

	apriModificaMoratorio(interesse: any) {
		this.moratorioModificato.id = interesse.id;
		this.moratorioModificato.data = interesse.data;
		this.moratorioModificato.tasso = interesse.tasso;
		this.moratorioModificato.comune_id = interesse.comune_id;
	}

	salvaModificaMoratorio() {
		console.log("salvaModificaMoratorio", this.moratorioModificato);
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.moratorioModificato.id });

		this.dataService.update("interessi_moratori", localFilters, this.moratorioModificato, true, (error,res) => {
			if(res){
				this.resetMoratori();
			}
		});
	}

	annullaModificaMoratorio() {
		this.resetMoratori();
	}

	eliminaInteresseMoratorio(interesse: any) {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: interesse.id });

		this.dataService.delete("interessi_moratori", localFilters, true, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE INTERESSE MORATORIO','si è verificato un errore');
			}
			if(res){
				this.resetMoratori();
			}
		});
	}

	ngOnDestroy() {
		this.interessiLegaliSync.unsubscribe();
		this.interessiMoratoriSync.unsubscribe();
	}
}
